import { useDispatch, useSelector } from "react-redux";
import { setContextMenuOpened } from "../../actions/contextMenuActions";
import { getContextMenuOptions, getContextMenuCoords, isContextMenuOpened } from "../../reducers/contextMenu";
import ContextMenu from "./ContextMenu";

const ContextualProvider = ({children}) => {
    const opened = useSelector(isContextMenuOpened);
    const coords = useSelector(getContextMenuCoords);
    const options = useSelector(getContextMenuOptions);
    const dispatch = useDispatch();

    return (
        <div id="general-container"
            onContextMenu={(e) => {
                e.preventDefault();

                dispatch(setContextMenuOpened(false));
            }}
        >
            {
                <ContextMenu open={opened} originX={coords.x} originY={coords.y} options={options} />
            }
            <div id="general-container"
                onClick={() => {
                    dispatch(setContextMenuOpened(false));
                }}>
                {children}
            </div>
        </div>
    )
}

export default ContextualProvider;